/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Branding_Use_BlockedInputs */

const cs_templates_branding_use_blocked = /** @type {(inputs: Templates_Branding_Use_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejdřív doplňte logo kanceláře (a avatar makléře, pokud šablona zobrazuje kartu makléře nebo QR).`)
};

const en_templates_branding_use_blocked = /** @type {(inputs: Templates_Branding_Use_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add the office logo first (and broker avatar if the template shows an agent card or QR).`)
};

/**
* | output |
* | --- |
* | "Add the office logo first (and broker avatar if the template shows an agent card or QR)." |
*
* @param {Templates_Branding_Use_BlockedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_branding_use_blocked = /** @type {((inputs?: Templates_Branding_Use_BlockedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Branding_Use_BlockedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_branding_use_blocked(inputs)
	return cs_templates_branding_use_blocked(inputs)
});